import React, {Component, Fragment} from 'react'
import {message, Row, Col} from 'antd';
import CabinetType from '../../components/cabinet-type'
import {getOrderDelivery} from '../../api'
import {DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR, PACKAGE_TYPE} from '../../utills/constants'
export default class BoxInfoView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            boxInfo: {},
        }
    }

    componentDidMount() {
        const {boxInfo} = this.props;
        if (boxInfo) {
            this.setState({boxInfo})
        }
    }

    componentDidUpdate(preProps, preState) {
        const {orderId, boxInfo} = this.props;
        if (preProps.orderId != orderId && orderId != null) {
            this.getOrderDeliveryInfo(orderId);
        }
        if (!Object.is(preProps.boxInfo, boxInfo) && boxInfo) {
            this.setState({boxInfo})
        }
    }

    getOrderDeliveryInfo = async (orderId) => {
        const result = await getOrderDelivery(orderId);
        if (result.code === 200) {
            if (result.data && result.data.length > 0) {
                this.setState({
                    boxInfo: result.data[0]
                });
            } else {
                this.setState({
                    boxInfo: {}
                });
            }
        } else if (result.code === 401) {
            message.error(result.message)
        }
    };

    render() {
        const {deliveryType, subType, volume,} = this.props;
        const {boxInfo} = this.state;
        const bRequired = DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType)
            || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'A');//公铁联运、一箱到底，集装箱号必填
        const notBRequired = deliveryType === 'D'
            || (DELIVERY_TYPE_HIGHWAY.hasOwnProperty(deliveryType) && subType === 'B')
            || DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType);//亚欧直达、特快且倒装运输、空运
        return (<Row className='box-info'>
                <Col span={6}>
                    <span className='label'>集装箱号：</span>
                    <span>{boxInfo.boxNo}</span>
                </Col>
                {notBRequired ? <Col span={6}>
                    <span className='label'>货物体积(CBM)：</span>
                    <span>{boxInfo.volume ? boxInfo.volume : volume}</span>
                </Col> : null}
                {notBRequired ? <Col span={6}>
                    <span className='label'>货物重量(kg)：</span>
                    <span>{boxInfo.goodsWeight}</span>
                </Col> : null}
                {bRequired ? <Col span={6}>
                    <span className='label'>箱型：</span>
                    <CabinetType value={boxInfo.cabinetType}/>
                </Col> : null}
                <Col span={6}>
                    <span className='label'>GPS编号：</span>
                    <span>{boxInfo.trailNo}</span>
                </Col>
                <Col span={6}>
                    <span className='label'>厂封号：</span>
                    <span>{boxInfo.factoryNo}</span>
                </Col>
                {bRequired ? <Col span={6}>
                    <span className='label'>皮重 (kg)：</span>
                    <span>{boxInfo.boxWeight}</span>
                </Col> : null}
                {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                    <Col span={6}>
                        <span className='label'>箱体标重：</span>
                        <span>{boxInfo.standardWeight}</span>
                    </Col> : null}
                {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ? null :
                    <Col span={6}>
                        <span className='label'>包装种类：</span>
                        <span>{PACKAGE_TYPE[boxInfo.packageCode]}</span>
                    </Col>}
                {bRequired ? <Col span={6}>
                    <span className='label'>提箱时间：</span>
                    <span>{boxInfo.pickupDt}</span>
                </Col> : null}
                {DELIVERY_TYPE_MIX.hasOwnProperty(deliveryType) ?
                    <Fragment>
                        <Col span={6}>
                            <span className='label'>业务编号：</span>
                            <span>{boxInfo.bussinessNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>运单号：</span>
                            <span>{boxInfo.deliveryNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>中车号：</span>
                            <span>{boxInfo.realPlateNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>跨境电商车板号：</span>
                            <span>{boxInfo.virtualPlateNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>请车时间：</span>
                            <span>{boxInfo.pleaseCarDt}</span>
                        </Col>
                    </Fragment> : null}
                {deliveryType === 'X' ?
                    <Fragment>
                        <Col span={6}>
                            <span className='label'>海关封号：</span>
                            <span>{boxInfo.customsNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>运抵号：</span>
                            <span>{boxInfo.arriveNo}</span>
                        </Col>
                    </Fragment> : null}
                {DELIVERY_TYPE_AIR.hasOwnProperty(deliveryType) ?
                    <Fragment>
                        <Col span={6}>
                            <span className='label'>航班号：</span>
                            <span>{boxInfo.flightNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>预计起飞时间：</span>
                            <span>{boxInfo.estimateLeaveDt ? boxInfo.estimateLeaveDt.substring(0, 16) : ''}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>预计到港时间：</span>
                            <span>{boxInfo.estimateArriveDt ? boxInfo.estimateArriveDt.substring(0, 16) : ''}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>落地机场：</span>
                            <span>{boxInfo.landingAirport}</span>
                        </Col>
                    </Fragment> : null}
            </Row>
        )
    }
}